module.exports = __webpack_public_path__ + "img/dm.d065af05.svg";